import Vue from 'vue';
import ReferredPageRecipients from '@/plugins/graphql/queries/v2/survey/referred-page-recipients.gql';
import { SurveyTaskCompleterModel } from '@/helpers/entities/models/SurveyTaskCompleterModel';
import { PER_PAGE } from '@/helpers/constants/app';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
export default Vue.extend({
    mixins: [PaginatorMixin],
    apollo: {
        registeredUsersWithReferral: {
            query: ReferredPageRecipients,
            variables() {
                return this.referredVariables;
            },
            update(data) {
                const referredUsers = data.registeredUsersWithReferral.edges;
                const referredUserNodes = (user) => {
                    return new SurveyTaskCompleterModel(user.node);
                };
                return referredUsers.map(referredUserNodes);
            },
            result({ data }) {
                const vm = this;
                vm.pageInfo = data.registeredUsersWithReferral.pageInfo;
                vm.totalCount = data.registeredUsersWithReferral.totalCount;
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            registeredUsersWithReferral: [],
        };
    },
    computed: {
        referredVariables() {
            const self = this;
            return {
                appUuid: this.appUuid,
                after: self.startCursor,
                first: PER_PAGE,
            };
        },
        perPage() {
            return PER_PAGE;
        },
        loading() {
            return this.$apollo.queries.registeredUsersWithReferral.loading;
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            const self = this;
            return this.$scopedSlots.default({
                registeredUsersWithReferral: this.registeredUsersWithReferral,
                pageInfo: self.pageInfo,
                startCursor: self.startCursor,
                totalCount: self.totalCount,
                fetchRecordsFrom: self.fetchRecordsFrom,
                perPage: this.perPage,
                loading: this.loading,
            });
        }
    },
});
